
import React  from 'react';
import {useParams} from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from "formik";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import CircularProgress from '@material-ui/core/CircularProgress';

import { makeStyles } from "@material-ui/core/styles";

import useApi from 'hooks/useApi';
import api from 'services/api';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 20,
    },
    paper: {
        marginTop: theme.spacing(4),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(3),
    },
    spinner: {
        marginTop: 50,
    }
}));



const validate = (values) => {
    const errors = {};
    if (!values.from || !values.to || !values.startTime) {
        errors.from = "Required";
    }

    if (!values.odoStart || !values.odoEnd) {
        errors.odoStart = "Must be greater than 0";
    }

    return errors;
};


const EditRide = (props) => {
    const classes = useStyles();
    const { id } = useParams();
    const [{data, isLoading}, ] = useApi.get(`/api/rides/get/${id}`);
    const [{isWorking}, saveRide] = useApi.post('/api/rides/update');

    const initialValues = {
        from: data ? data.Data.From : "",
        to: data ? data.Data.To : "",
        startTime: data ? data.Data.StartTime.slice(0, 16) : "",
        endTime: data ? data.Data.EndTime.slice(0, 16) : "",
        odoStart: data ? data.Data.OdoStart : "",
        odoEnd: data ? data.Data.OdoEnd : "" ,
        fuelLitres: data? data.Data.FuelLitres : "0",
        fuelPrice: data? data.Data.FuelPrice : "0.0",
        type: data ? data.Data.Type : "",
    };

    const onSubmit = (values, { setSubmitting }) => {
        console.log(values)
        try {
            saveRide({
                "id": parseInt(id),
                "From": values.from,
                "To": values.to,
                "StartTime": values.startTime,
                "EndTime": values.endTime,
                "OdoStart": values.odoStart,
                "OdoEnd": values.odoEnd,
                "FuelPrice": values.fuelPrice,
                "FuelLitres": values.fuelLitres,
                "Type": values.type,
            });
        }catch(error){
            console.log(error);
        }
        setSubmitting(false);
        props.history.push("/");
    };

    const onCancel = () => props.history.push("/");

    const onDelete = async () => {
        await api.delete(`/api/rides/delete/${id}`)
        props.history.push("/");
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>

                <Typography component="h1" variant="h5">
                    Edit Ride
                </Typography>

                {(isLoading || isWorking) && ( <CircularProgress className={classes.spinner} /> )}

                {!isLoading && (<>
                    <Formik
                        initialValues={initialValues}
                        validate={validate}
                        onSubmit={onSubmit}
                    >
                        <Form className={classes.form}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <Field name="from"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        label="From"
                                        InputLabelProps={{ shrink: true }}
                                        as={TextField}
                                    />
                                    <ErrorMessage name="from" />
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <Field
                                        name="to"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        label="To"
                                        InputLabelProps={{ shrink: true }}
                                        as={TextField}
                                    />
                                    <ErrorMessage name="to" />
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <Field
                                        name="startTime"
                                        type="datetime-local"
                                        fullWidth
                                        variant="outlined"
                                        label="Start Time"
                                        InputLabelProps={{ shrink: true }}
                                        as={TextField}
                                    />
                                    <ErrorMessage name="startTime" />
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <Field
                                        name="endTime"
                                        type="datetime-local"
                                        fullWidth
                                        variant="outlined"
                                        label="End Time"
                                        InputLabelProps={{ shrink: true }}
                                        as={TextField}
                                    />
                                    <ErrorMessage name="endTime" />
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <Field
                                        name="odoStart"
                                        type="number"
                                        fullWidth
                                        label="Odo Start"
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{
                                            pattern:"[0-9]*",
                                            inputMode:"numeric"
                                        }}
                                        as={TextField}
                                    />
                                    <ErrorMessage name="odoStart" />
                                </Grid>


                                <Grid item xs={12} sm={12}>
                                    <Field
                                        name="odoEnd"
                                        type="number"
                                        fullWidth
                                        label="Odo End"
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{
                                            pattern:"[0-9]*",
                                            inputMode:"numeric"
                                        }}
                                        as={TextField}
                                    />
                                    <ErrorMessage name="odoEnd" />
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <Field
                                        name="type"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        label="Type"
                                        InputLabelProps={{ shrink: true }}
                                        as={TextField}
                                    />
                                    <ErrorMessage name="type" />
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <Field
                                        name="fuelLitres"
                                        type="number"
                                        fullWidth
                                        label="Fuel (litres)"
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{
                                            pattern:"[0-9]*",
                                            inputMode:"numeric"
                                        }}
                                        as={TextField}
                                    />
                                    <ErrorMessage name="fuelLitres" />
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <Field
                                        name="fuelPrice"
                                        type="number"
                                        fullWidth
                                        label="Fuel (price)"
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{
                                            pattern:"[0-9.]*",
                                            inputMode:"numeric"
                                        }}
                                        as={TextField}
                                    />
                                    <ErrorMessage name="fuelPrice" />
                                </Grid>


                                <Grid item xs={12} sm={6}>
                                    <Button type="submit" fullWidth variant="contained" color="primary" > Save </Button>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Button type="button" fullWidth variant="contained" color="default" onClick={onCancel} >
                                        Cancel
                                    </Button>
                                    <br/>
                                    <br/>
                                    <br/>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Button type="button" fullWidth variant="contained" color="secondary" onClick={onDelete} >
                                        Delete
                                    </Button>
                                </Grid>

                            </Grid>
                        </Form>
                    </Formik>
                </>)}
            </div>
        </Container>
    );
};

export default EditRide;
